export enum SubsidiariesAPIRoutes {
    GET_SUBSIDIARIES = "subsidiary:query",
    EDIT_SUBSIDIARY = "subsidiary:edit"
}
